/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { SET_VISIBLE_MODAL_CORTE } from 'store/reducers/app';
import { toMoment } from 'utils/normalizers';
import { hasPermission } from 'utils/permission';

const routesThatNeedCorte = [
  '/recaudacion/caja',
  '/recaudacion/registro-de-pagos',
  '/recaudacion/pagos-externos/aplicacion',
];

const useCorte = (allowExpired = false) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const corte = useSelector(({ app }) => app.corte);
  const [corteSinCerrar, setCorteSinCerrar] = useState(false);
  const visibleModalCorte = useSelector(({ app }) => app.visibleModalCorte);
  const _allowExpired = corte?.permitir_expirado || allowExpired;

  const setVisibleModalCorte = (payload) => {
    dispatch({ type: SET_VISIBLE_MODAL_CORTE, payload });
  };

  useEffect(() => {
    const hasPermissionToPayOnExpiredCut = hasPermission('pagar_en_cortes_anteriores');

    const needCorte = routesThatNeedCorte.includes(location.pathname);
    if (!_allowExpired || !hasPermissionToPayOnExpiredCut) {
      if (corte) {
        const aperturaReal = toMoment(corte.apertura).format();
        const currentDay = toMoment(new Date()).format();
        if (currentDay !== aperturaReal && !corte?.reabierto) {
          setVisibleModalCorte(needCorte && true);
          setCorteSinCerrar(true);
        }
      } else if (needCorte) {
        setVisibleModalCorte(!corte?.reabierto);
      }
      if (!needCorte && visibleModalCorte) {
        setVisibleModalCorte(false);
      }
    }
  }, [corte, location.pathname]);

  const getAlertaText = () => {
    let txt = null;
    if (!corte) {
      txt = 'No hay corte';
    } else if (corteSinCerrar && !_allowExpired) {
      txt = 'Corte vencido';
    }
    return txt;
  };

  const Alerta = () => (getAlertaText() ? (
    <Typography.Text type="warning" style={{ paddingLeft: 5 }}>
      {getAlertaText()}
    </Typography.Text>
  ) : null);

  return {
    corte: corteSinCerrar && !_allowExpired ? null : corte,
    corteSinCerrar,
    alerta: <Alerta />,
    visibleModalCorte,
  };
};

export default useCorte;
